import { render, staticRenderFns } from "./add.vue?vue&type=template&id=5853c54a&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=5853c54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853c54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5853c54a')) {
      api.createRecord('5853c54a', component.options)
    } else {
      api.reload('5853c54a', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=5853c54a&scoped=true&", function () {
      api.rerender('5853c54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/liquidity/add.vue"
export default component.exports